import { env } from '../env';

/**
 * env().fedops.apps wrapper
 */
export function initializeFedopsApps() {
  env().fedops = env().fedops || {};
  env().fedops.apps = env().fedops.apps || {};
}

function getAppData(appName) {
  return ((env().fedops || {}).apps || {})[appName];
}

export function getStartLoadTime(appName) {
  return (getAppData(appName) || {}).startLoadTime || 0;
}

export default {
  initApp(appName) {
    env().fedops.apps[appName] = env().fedops.apps[appName] || {};
  },

  getStartLoadTime(appName) {
    const appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },

  setStartLoadTime(appName, startLoadTime) {
    return (getAppData(appName).startLoadTime = startLoadTime);
  },
};
